import { Card, CardBody, ListGroup, Table } from 'reactstrap';
import { generateRandomString } from '../adapters/randomAdapter';

interface Props<T> {
  title: string;
  cardHeader: string[];
  rows: RowItem[];
  striped?: boolean;
  hover?: boolean;
}

export interface RowItem {
  specialRow?: boolean;
  coloredRow?: string;
  rows: (string | React.ReactElement)[];
}

const SimpleCardTable = ({
  cardHeader,
  rows,
  title,
  hover = false,
  striped = false,
}: Props<any>) => {
  return (
    <Card>
      <CardBody>
        <ListGroup className="list my--3" flush>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6 className="heading-small text-muted mt-4 mb-4">{title}</h6>
          </div>
        </ListGroup>

        <div className="table-responsive">
          <Table
            className="align-items-center table-flush hei"
            striped={striped}
            hover={hover}
          >
            <thead className="thead-light">
              <tr>
                {cardHeader.map((header) => (
                  <th key={header} scope="col" className="text-nowrap">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td> No disponible</td>
                </tr>
              )}
              {rows.map((item) => (
                <tr
                  key={generateRandomString(6)}
                  className={item.specialRow ? item.coloredRow : ''}
                >
                  {item.rows.map((element) => (
                    <td
                      key={generateRandomString(6)}
                      style={{
                        maxWidth: '200px',
                        wordBreak: 'break-word', // Add word breaking
                        whiteSpace: 'normal', // Allow text to wrap
                        padding: '0.75rem',
                      }}
                      title={typeof element === 'string' ? element : ''}
                    >
                      {element}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default SimpleCardTable;
